export default "__VITE_ASSET__CYxsFZhG__"